import {
  CompanyDirectorInput,
  OfficerCompanyInput,
  OfficerCompanyType,
  OfficerPersonInput,
  OfficerPersonType,
  OfficerType,
  OfficerTypeEnum,
} from '@generated/graphql';
import { OfficerDialogState } from './officer-dialog-state.class';
import { DateTime } from 'luxon';

export class DirectorOfficerDialogState extends OfficerDialogState {
  setTitle(): this {
    if (this.mode === 'new') {
      this.title = 'Add Director';
    } else if (this.mode === 'edit') {
      this.title = 'Edit Director';
    }

    return this;
  }

  setInformationLabel(): this {
    this.informationLabel = 'Director Information';

    return this;
  }

  prepareEditData(data: CompanyDirectorInput): this {
    this.officerFormState.setEditData(
      data.officerPerson || data.officerCompany || undefined,
      undefined,
    );

    return this;
  }

  setLookupData(officer: OfficerType, type: OfficerTypeEnum): this {
    let officerName = 'officerPerson';
    let officerProfile: OfficerPersonInput | OfficerCompanyInput;

    if (type === OfficerTypeEnum.Corporate) {
      officerName = 'officerCompany';
      const castedOfficer = officer.officerProfile as OfficerCompanyType;

      officerProfile = this.mapOfficerCompanyInput(castedOfficer);
    } else {
      const castedOfficer = officer.officerProfile as OfficerPersonType;

      officerProfile = this.mapOfficerPersonInput(castedOfficer);
    }

    const transformedOfficer = {
      id: officer.id,
      officerType: type,
      isNominee: false,
      dateFrom: DateTime.now().toJSDate(),
      [officerName]: officerProfile,
      refId: officer.id,
    };

    this.setSelectedOfficerType(type)
      .createOfficerForm()
      .prepareEditData(transformedOfficer)
      .disableOfficerFormForExistingReference();

    return this;
  }

  isOfficerFormValid(): boolean {
    if (!this.officerFormState) {
      return false;
    }

    return this.getOfficerForm().disabled ? true : this.getOfficerForm().valid;
  }
}
